import React from "react";
import { Box, Typography } from "@mui/material";
import { getUavStateIcon, uavStateColour } from "../features/aircraft/state";

export const AircraftNub = (props: {
  uavState?: string;
  flightMode?: string;
  uavId: string;
  stale?: boolean;
  connecting?: boolean;
  loadingMission?: boolean;
  inEmergency?: boolean;
}) => {
  const MNAIcon = getUavStateIcon(
    props.uavState,
    props.flightMode,
    props.stale || props.connecting,
    props.loadingMission,
    props.inEmergency
  );

  const stateColours = uavStateColour(
    props.uavState,
    props.flightMode,
    props.stale || props.connecting,
    props.loadingMission,
    props.inEmergency
  );

  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      sx={{
        maxHeight: "40px",
        maxWidth: "79px",
        height: "40px",
        width: "79px",
        boxSizing: "border-box",
        borderRadius: 2,
        border: 2,
        borderColor: "#101828",
        backgroundColor: stateColours.background,
      }}
      alignItems={"center"}
    >
      <Box
        display={"flex"}
        width={45}
        alignItems="center"
        justifyItems="center"
        sx={{}}
      >
        <Typography
          sx={{
            width: "100%",
            textJustify: "center",
            textAlign: "center",
          }}
          variant={"body2"}
          fontWeight={"600"}
          color={stateColours.text}
        >
          {props.uavId}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "1px",
          backgroundColor: "#101828",
          height: "100%",
        }}
      />
      <Box
        display={"flex"}
        width={34}
        alignItems="center"
        justifyItems="center"
      >
        <Box
          display={"flex"}
          sx={{ width: "100%" }}
          alignItems="center"
          justifyItems="center"
          pl={1}
        >
          <MNAIcon
            style={{
              width: 16,
              height: 16,
              justifySelf: "center",
              alignSelf: "center",
              color: stateColours.text,
              animation:
                !props.uavState || props.stale || props.connecting
                  ? "rotate 2s linear infinite"
                  : "",
            }}
            stroke={stateColours.text}
          />
        </Box>
      </Box>
    </Box>
  );
};
